import { useState, useEffect } from 'react';
import Modal from '../../../../modal/modal';
import Select from '../../../../select/select';
import './SelectSubsidiary.scss'
import Button from '../../../../button/button';

const SelectSubsidiary = ({ isOpen, onClose, job_position = '' }) => {
    const [selectedSubsidiary, setSelectedSubsidiary] = useState('');
    const subsidiaries = [
        { value: "1", label: "Plaza estrella" },
        { value: "2", label: "Plaza Bugambilias" },
        { value: "3", label: "Plaza Aranjuez" },
    ];

    const handleSubsidiaryChange = (selectedOption) => {
        setSelectedSubsidiary(selectedOption);
    };

    const saveSubsidiary = () => {
        if (!selectedSubsidiary) {
            alert('Por favor selecciona una sucursal.');
            return;
        }
        
        //Set to local storage
        localStorage.setItem(`${job_position}SubsidiarySession`, selectedSubsidiary);
        //Close modal
        onClose();
    };
    return (
        <Modal isOpen={isOpen} onClose={onClose} overlayClick={false}>
            <div className='select-shift-subsidiary'>
                <h1 className='title-1'> Seleccion de sucursal</h1>
                <h1 className='emphasis-2'>Selecciona la sucursal en que te encuentras en este momento</h1>
                <Select options={subsidiaries}
                    value={selectedSubsidiary}
                    onChange={(e)=>handleSubsidiaryChange(e.target.value)}
                    placeholder={'Sucursal'} ></Select>

                <div className="confirm-buttons-section">
                    {/* <Button text="Cancelar" backgroundColor="red" /> */}
                    <Button text="Confirmar" onClick={saveSubsidiary} />
                </div>
            </div>
        </Modal>
    )
}

export default SelectSubsidiary;